<template>
  <e-charts
    ref="line"
    autoresize
    :option="option"
    theme="theme-color"
    auto-resize
    :update-options="{notMerge:true}"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import { ref, toRef, watch } from '@vue/composition-api'
import { registerTheme, use } from 'echarts/core'
import {
  BarChart, LineChart, LinesChart, PieChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  LegendScrollComponent, MarkLineComponent, MarkPointComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components'
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'
import { formatCurrencyNonDecimal, truncateString } from '@core/utils/utils'
import theme from '../theme.json'

use([
  BarChart,
  LineChart,
  PieChart,
  LinesChart,
  LegendScrollComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
])
registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    mobile: {
      type: Object,
      default: () => ({ mobile: false }),
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const chartData = toRef(props, 'chartData')
    // const mobile = toRef(props, 'mobile')

    const option = ref({
      title: {
        text: 'Evolução das vendas média/mês por unidade médica',
        left: 'center',
      },
      legend: {
        bottom: '0',
        padding: [0, 0],
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        },
      },
      dataset: {
        dimensions: [],
        source: [],
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          interval: 0,
          rotate: 20,
          formatter: value => truncateString(value, 15),
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          rotate: 30,
          formatter: value => (value ? `${formatCurrencyNonDecimal(value)}` : ''),
        },
      },
      series: [],
    })

    const getYears = data => {
      const yearsSet = new Set()
      const ids = Object.keys(data.average_year_per_workplace)
      ids.forEach(id => {
        const years = Object.keys(data.average_year_per_workplace[id].average_year)
        years.forEach(year => yearsSet.add(year))
      })
      return Array.from(yearsSet).sort()
    }

    watch(chartData, data => {
      if (!data || !data.average_year_per_workplace) return
      const ids = Object.keys(data.average_year_per_workplace)
      const years = getYears(data)
      option.value.dataset.dimensions = ['workplace', ...years]
      const series = years.map(() => ({
        type: 'bar',
        markPoint: {
          data: [],
        },
      }))

      ids.forEach((id, index) => {
        const workplace = data.average_year_per_workplace[id]
        years.forEach((year, yearIndex) => {
          const percent = Math.round((workplace.average_year_percentage[year] || 0) * 100) / 100
          if (percent !== 0) {
            const isPositive = percent >= 0
            const point = {
              name: '%',
              value: `${percent}%`,
              xAxis: index,
              yAxis: workplace.average_year[year] / 100,
              itemStyle: {
                color: isPositive ? '#28a745' : '#dc3545',
              },
              label: {
                verticalAlign: 'top',
                position: 'top',
                fontSize: '11px',
                distance: 18,
                rotate: 70,
              },
              symbol: 'triangle',
              symbolRotate: isPositive ? '0' : '180',
              symbolSize: '10',
              symbolOffset: [0, '-8px'],
            }
            series[yearIndex].markPoint.data.push(point)
          }
        })
      })

      option.value.series = series
      const source = []
      ids.forEach(id => {
        const workplace = data.average_year_per_workplace[id]
        const yearsValues = {}
        Object.keys(workplace.average_year).forEach(year => {
          yearsValues[year] = workplace.average_year[year] / 100
        })
        source.push({
          workplace: workplace.workplace_name,
          ...yearsValues,
        })
      })
      option.value.dataset.source = source
    })

    return {
      option,
    }
  },
}
</script>
